import React from 'react';
import Question from '../Components/Question';

function HasKnownFault() {
    return Question({
        question: (<>Is there a known gene fault in the family?</>),
        answers: [
            {
                link: "/known-fault",
                text: "Yes",
                properties: {
                    positive: true,
                    floated: "left"
                }
            },
            {
                link: "/no-gene-fault",
                text: "No",
                properties: {
                    negative: true,
                    floated: "right"
                }
            },
        ]
    });
}

export default HasKnownFault;
